module.exports = __webpack_public_path__ + "img/2D.6f10ee6a.png";